import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-light-svg-icons'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'

import Box from '../Box'

import styles from './styles.scss'

const defaultState = {
  showOptionsModal: false,
}

const PageZoomControl = (props) => {
  const {
    availableZooms,
    callbacks: { performZoomAction, selectZoomValue, zoomToBestFit },
    decreaseIcon,
    increaseIcon,
    selectedZoom,
    showBestFitOption,
    style,
    theme,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { showOptionsModal } = state

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showOptionsModal })

  useEffect(() => {
    if (isClickedOutside && showOptionsModal){
      setState({ showOptionsModal: false })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  return (
    <Box className={classnames(styles.root, styles[`theme-${theme}`])} width="auto" style={style}>
      <a className={classnames(styles.action, styles.left)} onClick={() => performZoomAction('decrease')} tabIndex="1">
        {decreaseIcon}
      </a>
      <a className={styles.value} onClick={() => setState({ showOptionsModal: true })} tabIndex="2">
        {selectedZoom * 100}%
      </a>
      <a className={classnames(styles.action, styles.right)} onClick={() => performZoomAction('increase')} tabIndex="3">
        {increaseIcon}
      </a>

      {showOptionsModal && (
        <ul className={styles.options} ref={contentEl}>
          {showBestFitOption && (
            <li>
              <a onClick={() => zoomToBestFit()} tabIndex="0">
                Best Fit
              </a>
            </li>
          )}

          {availableZooms.map((zoom) => {
            const percentage = zoom * 100
            const selected = selectedZoom === zoom

            return (
              <li key={`zoom_${zoom}`}>
                <a className={selected ? styles.selected : null} onClick={() => selectZoomValue(zoom)} tabIndex="0">
                  {percentage}%
                </a>
              </li>
            )
          })}
        </ul>
      )}
    </Box>
  )
}

PageZoomControl.propTypes = {
  availableZooms: PropTypes.array,
  callbacks: PropTypes.shape({
    selectZoomValue: PropTypes.func.isRequired,
    performZoomAction: PropTypes.func.isRequired,
    zoomToBestFit: PropTypes.func.isRequired,
  }).isRequired,
  selectedZoom: PropTypes.number,
  showBestFitOption: PropTypes.bool,
  style: PropTypes.object,
  theme: PropTypes.string,
}

PageZoomControl.defaultProps = {
  availableZooms: [],
  decreaseIcon: <FontAwesomeIcon icon={faMinus} />,
  increaseIcon: <FontAwesomeIcon icon={faPlus} />,
  selectedZoom: 1,
  showBestFitOption: false,
  style: {},
  theme: 'white',
}

export default PageZoomControl
